import { rateLimitStatusesQuery } from '#pplx/frontend/apps/ask/user-settings/rateLimitStatusesQuery.js';
import { useIsUserLoggedIn } from '#pplx/frontend/auth/userHooks.js';
import { logger } from '#pplx/frontend/logger/browser.js';
import { useQuery } from '#pplx/frontend/react-query/useQuery.js';
import { useCallback, useMemo } from 'react';
const DEFAULT_RATE_LIMIT = {
    available: false,
    remaining_detail: {
        kind: 'exact',
        remaining: 0,
    },
};
export const useRateLimits = ({ enabled = true, reason, refetchOnMount = 'always', }) => {
    const isUserLoggedIn = useIsUserLoggedIn();
    const { data, isSuccess, isFetching } = useQuery(rateLimitStatusesQuery.getOptions({ reason }, {}, {
        enabled: isUserLoggedIn && enabled,
        refetchOnMount,
        // Poll /status every 30s ONLY WHEN free-tier-rate-limited so the user gets
        // unblocked on leaky-bucket refill without a manual refresh.
        refetchInterval: (query) => {
            const freeQueries = query.state.data?.free_queries;
            return freeQueries?.remaining_detail.kind === 'exact' &&
                freeQueries.remaining_detail.remaining === 0
                ? 30_000
                : false;
        },
    }));
    const loaded = isSuccess && !isFetching && !!data;
    const getModeRateLimit = useCallback((mode) => {
        try {
            return data?.modes[mode] ?? DEFAULT_RATE_LIMIT;
        }
        catch (error) {
            logger.warn('[useRateLimitsQuery] Failed to get mode rate limit', {
                loaded,
                mode,
                error,
            });
            return DEFAULT_RATE_LIMIT;
        }
    }, [data, loaded]);
    return useMemo(() => ({
        loaded,
        getModeRateLimit,
    }), [loaded, getModeRateLimit]);
};
//# sourceMappingURL=useRateLimits.js.map